import { useDispatch, useSelector } from "react-redux"
import BulkOrderDetail from "./BulkOrderAssetDetail"
import PurchaseDetail from "../PurchaseDetail"
import VendorDetail from "../VendorDetail"
import PurchaseOrder from "../PurchaseOrder"
import TaskBulkOrder from "../TaskBulkOrder"
import { useEffect, useMemo, useRef, useState } from "react"
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import { getBulkOrderFleetPurchaseDetail, getBulkOrderPurchaseOrder, getBulkOrderVendorDetails, getSaveVendorDetails, setBulkOrderAlert, setBulkOrderFleetHeader, setSaveVendorDetails } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction"
import { useNavigate } from "react-router-dom"
import navOperations from "redux/Navigation/operations";
import navSelectors from "redux/Navigation/selectors"
import { commonStepperFourOnClick, commonStepperOneOnClick, commonStepperThreeOnClick, commonStepperTwoOnclick, isEmail, isValidPhone } from "utils"
import userSelectors from "redux/UserProfile/selectors";
import { CONSTANTS } from "client/utils/constants"

const PurchaseDetailContainer = (props?: any) => {
   const {
    itemDetails
   } = props

  const { bulkOrderFleetDetails,
    bulkOrderVendorDetails,
    bulkOrderPurchaseOrder,
    userDetails,
    isVendorDetailsSaved,
    bulkOrderAlert,
    bulkOrderFleetPurchaseDetails,
    navItem,
    headerNav
  }: any = useSelector((state: any) => ({
      bulkOrderFleetDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetDetails,
      bulkOrderVendorDetails: state.PurchaseBulkOrderReducer.bulkOrderVendorDetails,
      bulkOrderPurchaseOrder: state.PurchaseBulkOrderReducer.bulkOrderPurchaseOrder,
      userDetails: userSelectors.getUserDetails(state),
      isVendorDetailsSaved: state.PurchaseBulkOrderReducer.isVendorDetailsSaved,
      bulkOrderAlert: state.PurchaseBulkOrderReducer.bulkOrderAlert,
      bulkOrderFleetPurchaseDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetPurchaseDetails,
      navItem: navSelectors.GetNavItem(state),
      headerNav: navSelectors.GetHeaderNav(state)
    }))

  const id = props?.id
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);
  const StepperRef = useRef<any>(null);
  const [activeStepper, setActiveStepper] = useState<number>(1);
  const [isButtonDisable, setIsButtondisable] = useState<any>(true);
  const [errors, setErrors] = useState<any>({});
  const [stepperClicked, setStepperClicked] = useState<any>(0);
  const [isNextClicked, setIsNextClicked] = useState<any>(false);
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });

  const purchaseOrderStepperData = useMemo(() => {
    let bulkOrderFleetDetailsTemp = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    if (bulkOrderFleetDetailsTemp?.length) {
      if (id == bulkOrderFleetDetailsTemp[0]?.orderId) {
        return bulkOrderFleetDetailsTemp.find(
          (item: any) =>
            item?.orderDetailId === itemDetails?.orderDetailId
        ) || {}
      }
    }
  }, [bulkOrderFleetDetails]);

  useEffect(() => {
    if (id == itemDetails?.orderId) {
      setActiveStepper(parseInt(itemDetails?.stepNumber))
    }
  }, [itemDetails?.orderDetailId])
  
  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  };

  useEffect(() => {
    if (bulkOrderAlert?.orderDetailId) {
      const timer = setTimeout(() => {
        dispatch(setBulkOrderAlert(undefined));
      }, 5000);
      return () => clearTimeout(timer)
    }
  }, [bulkOrderAlert?.orderDetailId])

  const handleClickCancel = () => {
    let decriptionTxt = (
      <>
        <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
      </>
    );

    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "UNSAVED CHANGES",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "No",
      primaryBtnText: "Yes",
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      },
      popupPrimarybtnOnclick: () => {
        dispatchNav(navItem);
        dispatchHeaderNav(headerNav);
        navigate('/ordermanagement');
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      }
    });
  };

  const hasValidVendorDetails = (changedVendorDetails?: any) => {
    setErrors({
      vendorAbNumber: !changedVendorDetails?.vendorDetails?.vendorAbNumber,
      vendorName: !changedVendorDetails?.vendorDetails?.vendorName || changedVendorDetails?.vendorDetails?.vendorName?.length > 50,
      vendorAdd1: !changedVendorDetails?.vendorDetails?.vendorAdd1 || changedVendorDetails?.vendorDetails?.vendorAdd1?.length > 50,
      vendorAdd2: (changedVendorDetails?.vendorDetails?.vendorAdd2 ?? "")?.length > 50,
      vendorState: !changedVendorDetails?.vendorDetails?.vendorState || changedVendorDetails?.vendorDetails?.vendorState?.length > 2,
      vendorCity: !changedVendorDetails?.vendorDetails?.vendorCity || changedVendorDetails?.vendorDetails?.vendorCity?.length > 50,
      vendorZip: !changedVendorDetails?.vendorDetails?.vendorZip || changedVendorDetails?.vendorDetails?.vendorZip?.length > 12,
      vendorPhone: !changedVendorDetails?.vendorDetails?.vendorPhone || !isValidPhone(changedVendorDetails?.vendorDetails?.vendorPhone),
      vendorContactEmail: !changedVendorDetails?.vendorDetails?.vendorContactEmail || isEmail(changedVendorDetails?.vendorDetails?.vendorContactEmail) || changedVendorDetails?.vendorDetails?.vendorContactEmail?.length > 50
    });
    return (
      changedVendorDetails?.vendorDetails &&
      changedVendorDetails?.vendorDetails.vendorAbNumber &&
      changedVendorDetails?.vendorDetails.vendorName &&
      changedVendorDetails?.vendorDetails?.vendorName?.length <= 50 &&
      changedVendorDetails.vendorDetails.vendorAdd1 &&
      changedVendorDetails?.vendorDetails?.vendorAdd1?.length <= 50 &&
      (changedVendorDetails?.vendorDetails?.vendorAdd2 ?? "")?.length <= 50 &&
      changedVendorDetails.vendorDetails.vendorState &&
      changedVendorDetails?.vendorDetails?.vendorState?.length <= 2 &&
      changedVendorDetails.vendorDetails.vendorCity &&
      changedVendorDetails?.vendorDetails?.vendorCity?.length <= 50 &&
      changedVendorDetails.vendorDetails.vendorZip &&
      changedVendorDetails?.vendorDetails?.vendorZip?.length <= 12 &&
      !!changedVendorDetails?.vendorDetails?.vendorPhone &&
      isValidPhone(changedVendorDetails?.vendorDetails?.vendorPhone) &&
      !!changedVendorDetails?.vendorDetails?.vendorContactEmail &&
      !isEmail(changedVendorDetails?.vendorDetails?.vendorContactEmail) &&
      changedVendorDetails?.vendorDetails?.vendorContactEmail?.length <= 50
    );
  };

  const saveVendorDetails = (changedVendorDetails?: any) => {
    let payload = {
      requestDetailId: changedVendorDetails?.orderDetailId,
      poVendor: {
        fleetRequestVendorId: 0,
        vendorAbNumber: parseInt(changedVendorDetails?.vendorDetails?.vendorAbNumber),
        vendorName: changedVendorDetails?.vendorDetails?.vendorName,
        vendorAdd1: changedVendorDetails?.vendorDetails?.vendorAdd1,
        vendorAdd2: changedVendorDetails?.vendorDetails?.vendorAdd2,
        vendorAdd3: '',
        vendorCity: changedVendorDetails?.vendorDetails?.vendorCity,
        vendorState: changedVendorDetails?.vendorDetails?.vendorState,
        vendorZip: changedVendorDetails?.vendorDetails?.vendorZip,
        vendorPhone: changedVendorDetails?.vendorDetails?.vendorPhone,
        vendorContactEmail: changedVendorDetails?.vendorDetails?.vendorContactEmail
      },
      savedBy: userDetails?.emailId
    }
    dispatch(getSaveVendorDetails(payload));
  }

  const handleClickNext = (e?: any) => {
    if (activeStepper == 1) {
      setIsNextClicked(false)
      setActiveStepper((next) => next + 1);
      dispatch(getBulkOrderVendorDetails(purchaseOrderStepperData?.orderDetailId))
    } else if (activeStepper == 2) {
      setIsNextClicked(true)
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId)
      let isValidVendorDetails = hasValidVendorDetails(changedVendorDetails ?? {})
      if (isValidVendorDetails) {
        setIsButtondisable(false);
        saveVendorDetails(changedVendorDetails);
      } else {
        setIsButtondisable(true);
      }
    } else if (activeStepper == 3) {
      const isPOCreatedForAllItems = purchaseOrderStepperData?.purchaseDetails?.items?.every((item: any) => item?.status === CONSTANTS.PO_STATUS.COMPLETE)
      if (isPOCreatedForAllItems) {
        setActiveStepper((next) => next + 1);
        setIsButtondisable(false);
      } else {
        setIsButtondisable(true);
      }
    }
  }

  useEffect(() => {
    if (isVendorDetailsSaved?.response && isVendorDetailsSaved?.orderDetailId == purchaseOrderStepperData?.orderDetailId && isVendorDetailsSaved != null) {
      let isVendorChangedTemp = false;
      if (bulkOrderFleetDetails) {
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
        if (purchaseOrderStepperData?.orderDetailId == isVendorDetailsSaved?.orderDetailId) {
          bulkOrderFleetDetailsTemp?.map((item?: any) => {
            if (item?.orderDetailId == isVendorDetailsSaved?.orderDetailId) {
              isVendorChangedTemp = item?.isVenorChanged
              if (item?.vendorDetails?.vendorName) {
                item.isVendorSaved = true
              } else {
                item.isVendorSaved = false
              }
              item.isVendorChanged = false
            }
          })
          dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
        }
      }
      if (isVendorChangedTemp && stepperClicked == 3) {
        StepperThreeClickAction()
        setStepperClicked(0)
      } else if (isVendorChangedTemp && stepperClicked == 4) {
        StepperFourClickAction()
        setStepperClicked(0)
      } else {
        setActiveStepper((next) => next + 1);
      }

      dispatch(getBulkOrderPurchaseOrder(isVendorDetailsSaved?.orderDetailId));
      dispatch(setSaveVendorDetails(null));
    } else if (!isVendorDetailsSaved?.response && isVendorDetailsSaved?.orderDetailId == purchaseOrderStepperData?.orderDetailId && isVendorDetailsSaved != null) {
      dispatch(setBulkOrderAlert({
        showAlert: true,
        type: "warning",
        text: "Error occured while saving the value.",
        orderDetailId: isVendorDetailsSaved?.orderDetailId,
      }))
      dispatch(setSaveVendorDetails(null))
    }
  }, [isVendorDetailsSaved])

  const isShowComplete = (itemDetails?: any) => {
    let count = 0
    for (let i = 0; i <= itemDetails?.taskHeaderDetails?.length; i++) {
      if (itemDetails?.taskHeaderDetails[i]?.itemStatus == CONSTANTS?.ITEM_STATUS.REQUISITION_COMPLETE) {
        count = count + 1
      }
    }
    if (count == itemDetails?.taskHeaderDetails?.length) {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    if(purchaseOrderStepperData){
    if ((activeStepper == 2 || activeStepper == 3)) {
      StepperRef?.current?.children[activeStepper - 1].classList.add("active");
    }
    else if (isShowComplete(purchaseOrderStepperData) && activeStepper == 4) {
      StepperRef?.current?.children[activeStepper - 1]?.classList.remove("active");
      StepperRef?.current?.children[activeStepper - 1]?.classList.add("completed");
    }
    else if ((!isShowComplete(purchaseOrderStepperData) && activeStepper == 4)) {
      StepperRef?.current?.children[activeStepper - 1].classList.add("active");
    }
  }
  }, [activeStepper, JSON.stringify(purchaseOrderStepperData?.taskHeaderDetails)])

  const StepperOneClick = (e: any) => {
    e.preventDefault()
    e.stopPropagation();
    commonStepperOneOnClick(setActiveStepper, activeStepper, StepperRef)
    dispatch(getBulkOrderFleetPurchaseDetail(purchaseOrderStepperData?.purchaseDetails?.requestDetailId))
  }

  const ValidateStepperOne = () => {
    let isValid = true;
    if (purchaseOrderStepperData?.purchaseDetails?.items?.length > 0) {
      purchaseOrderStepperData?.purchaseDetails?.items?.map((childItem: any) => {
        if (!childItem?.assetNumber || childItem?.assetNumberError?.length > 0) {
          isValid = false
        }
      })
    }
    return isValid
  }

  const invalidPopup = () => {
    let decriptionTxt = (
      <>
        <p>Please fill all the details before continue order further.</p>
      </>
    );

    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      }
    });
  };

  const StepperTwoClick = (e: any) => {
    e.preventDefault()
    e.stopPropagation();
    if (ValidateStepperOne()) {
      setIsNextClicked(false)
      dispatch(getBulkOrderVendorDetails(purchaseOrderStepperData?.orderDetailId))
      commonStepperTwoOnclick(setActiveStepper, activeStepper, StepperRef)
    } else {
      invalidPopup();
    }
  }

  const StepperThreeClickAction = () => {
    dispatch(getBulkOrderPurchaseOrder(purchaseOrderStepperData?.orderDetailId))
    commonStepperThreeOnClick(setActiveStepper, activeStepper, StepperRef)
  }

  const StepperFourClickAction = () => {
    commonStepperFourOnClick(setActiveStepper, activeStepper, StepperRef)
  }

  const StepperThreeClick = (e: any) => {
    setIsNextClicked(true)
    e.preventDefault()
    e.stopPropagation();
    setStepperClicked(3)
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId)
    if (ValidateStepperOne() && hasValidVendorDetails(changedVendorDetails)) {
      if (purchaseOrderStepperData?.isVendorChanged) {
        saveVendorDetails(changedVendorDetails)
      } else {
        StepperThreeClickAction()
      }
    } else {
      invalidPopup();
    }
  }

  const StepperFourClick = (e: any) => {
    setIsNextClicked(true)
    e.preventDefault()
    e.stopPropagation();
    setStepperClicked(4)
    const isPOCreatedForAllItems = purchaseOrderStepperData?.purchaseDetails?.items?.every((item: any) => item?.status === CONSTANTS.PO_STATUS.COMPLETE)
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId)
    if (ValidateStepperOne() && hasValidVendorDetails(changedVendorDetails) && isPOCreatedForAllItems && !purchaseOrderStepperData?.isPoPartiallyCreated && !purchaseOrderStepperData?.isNonConsolidatedPOCreated) {
      if (purchaseOrderStepperData?.isVendorChanged) {
        saveVendorDetails(changedVendorDetails)
      } else {
        StepperFourClickAction()
      }
    } else {
      invalidPopup()
    }
  }
  const stepperListData: Array<any> = [
    {
      text: "Purchase Detail",
      step: "1",
      onClick: StepperOneClick
    },
    {
      text: 'Vendor Detail',
      step: "2",
      onClick: StepperTwoClick
    },
    {
      text: "Purchase Order",
      step: "3",
      onClick: StepperThreeClick
    },
    {
      text: "Tasks",
      step: "4",
      onClick: StepperFourClick
    },
  ]

  const panelList = [
    {
      component: <PurchaseDetail
        purchaseOrderStepperData={purchaseOrderStepperData}
        setIsButtondisable={setIsButtondisable}
        isButtonDisable={isButtonDisable}
        activeStepper={activeStepper}
        id = {id}
      />
    },
    {
      component: <VendorDetail
        purchaseOrderStepperData={purchaseOrderStepperData}
        setIsButtondisable={setIsButtondisable}
        isButtonDisable={isButtonDisable}
        setErrors={setErrors}
        hasValidVendorDetails={hasValidVendorDetails}
        errors={errors}
        isNextClicked = {isNextClicked}
      />
    },
    {
      component: <PurchaseOrder
        purchaseOrderStepperData={purchaseOrderStepperData}
        setIsButtondisable={setIsButtondisable}
        isButtonDisable={isButtonDisable}
      />
    },
    {
      component: <TaskBulkOrder
        activeStepper={activeStepper}
        purchaseOrderStepperData={purchaseOrderStepperData}
      />
    }
  ]

  useEffect(() => {
    if (bulkOrderVendorDetails?.response) {
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      if (purchaseOrderStepperData?.orderDetailId == bulkOrderVendorDetails?.orderDetailId) {
        bulkOrderFleetDetailsTemp?.map((item?: any) => {
          if (item?.orderDetailId == bulkOrderVendorDetails?.orderDetailId) {
            item.vendorDetails = bulkOrderVendorDetails?.response
            if (bulkOrderVendorDetails?.response?.vendorName) {
              item.isVendorSaved = true
            } else {
              item.isVendorSaved = false
            }
            item.isVendorChanged = false
          }
        })
        dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
      }
    }
  }, [bulkOrderVendorDetails])

  useEffect(() => {
    if (bulkOrderPurchaseOrder?.response) {
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      if (purchaseOrderStepperData?.orderDetailId == bulkOrderPurchaseOrder?.orderDetailId) {
        bulkOrderFleetDetailsTemp?.map((item?: any) => {
          if (item?.orderDetailId == bulkOrderPurchaseOrder?.orderDetailId) {
            item.purchaseOrder = bulkOrderPurchaseOrder?.response
          }
        })
        dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
      }
    }
  }, [bulkOrderPurchaseOrder])

  useEffect(() => {
    if (bulkOrderFleetPurchaseDetails) {
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      bulkOrderFleetDetailsTemp?.map((item?: any) => {
        if (item?.orderDetailId == bulkOrderFleetPurchaseDetails?.requestDetailId) {
          item.isNonConsolidatedPOCreated = false
          item.purchaseDetails = bulkOrderFleetPurchaseDetails
          let count = 0
          item?.purchaseDetails?.items?.map((fleetPOItem?: any) => {
            if ([CONSTANTS.PO_STATUS.IN_PROGRESS, CONSTANTS.PO_STATUS.COMPLETE].includes(fleetPOItem?.status)) {
              count = count + 1
            }
          })
          if (count > 0) {
            item.isPOCreated = true
          } else {
            item.isPOCreated = false
          }
          if (item?.fleetRequests?.length == count) {
            item.isPoPartiallyCreated = false
          } else {
            item.isPoPartiallyCreated = true
          }
        }
      })
      dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
    }
  }, [bulkOrderFleetPurchaseDetails])

  const dismissAlert = () => dispatch(setBulkOrderAlert(undefined));

  return (
    <BulkOrderDetail
      stepperListData={stepperListData}
      panelList={panelList}
      StepperRef={StepperRef}
      activeStepper={activeStepper}
      handleClickCancel={handleClickCancel}
      handleClickNext={handleClickNext}
      isButtonDisable={isButtonDisable}
      hideDialog={hideDialog}
      Popupcontent={Popupcontent}
      purchaseOrderStepperData={purchaseOrderStepperData}
      dismissAlert={dismissAlert}
      bulkOrderAlert={bulkOrderAlert}
    />
  )
}

export default PurchaseDetailContainer